import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../constants/constants';
import { getValueFromStorage } from '../helpers/helpers';

export const UsersApi = createApi({
  reducerPath: 'users',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: headers => {
      headers.set('Content-type', 'application/json');
      headers.set('authorization', `Bearer ${getValueFromStorage('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getUsers: builder.query({
      query: ({ currentPage = 1, resultPerPage = 10, search, unpaidOnly }) => ({
        url: `/api/user/getUsers`,
        method: 'GET',
        params: {
          current_page: currentPage,
          result_per_page: resultPerPage,
          search,
          unpaid_only: unpaidOnly,
        },
      }),
    }),
    getUserById: builder.query({
      query: ({ id }) => {
        return {
          url: `/api/user/getUser/${id}`,
          method: 'GET',
        };
      },
    }),
    updateUser: builder.mutation({
      query: ({ id, body }) => ({
        url: `/api/user/updateUser/${id}`,
        method: 'PUT',
        body: { user: body },
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserByIdQuery,
  useLazyGetUserByIdQuery,
  useLazyGetUsersQuery,
  useUpdateUserMutation,
} = UsersApi;
